import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useIntl } from 'react-intl';
import SimpleDropdown from '~/modules/common/components/SimpleDropdown';
import { getOptions } from './const';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%'
  },
  select: {
    fontSize: theme.typography.body2.fontSize
  }
}));

const inputLabelProps = {
  id: 'consolidate-bills-by-label'
};

export const ConsolidateBillsByDropdown = ({ value: val, onChange }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const options = useMemo(() => getOptions(formatMessage), [formatMessage]);

  const dropdownClasses = useMemo(
    () => ({
      container: classes.container,
      select: classes.select
    }),
    [classes.container, classes.select]
  );

  const value = useMemo(
    () => ({
      id: val,
      displayText: options.find(({ id }) => id === val).displayText
    }),
    [options, val]
  );

  const selectProps = useMemo(
    () => ({
      labelId: 'consolidate-bills-by-label',
      id: 'consolidate-bills-by',
      renderValue: selectedValue =>
        options.find(({ id }) => id === selectedValue).displayText
    }),
    [options]
  );

  return (
    <SimpleDropdown
      variant="filled"
      options={options}
      onChange={onChange}
      value={value}
      classes={dropdownClasses}
      noneOption={false}
      labelWidth={200}
      disableSort
      label={formatMessage({
        id: 'billingCard.subTitle.consolidateBillsBy.label'
      })}
      ariaLabel={formatMessage({
        id: 'billingCard.subTitle.consolidateBillsBy.label'
      })}
      selectProps={selectProps}
      inputLabelProps={inputLabelProps}
    />
  );
};

ConsolidateBillsByDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default ConsolidateBillsByDropdown;
